import React from 'react'

import {isEqual} from 'lodash'
import {Field} from 'react-final-form'

/**
 * Field component that uses deep equality comparison for determining if field value has changed.
 * This is especially useful for array and object field values to properly detect when they
 * return to their initial state.
 *
 * @param {import('react-final-form').FieldProps} props - All standard props accepted by react-final-form's Field component
 * @returns {import('react').ReactElement} - A Field component with deep equality comparison
 *
 */
export const DeepEqualityField = props => <Field {...props} isEqual={isEqual} />
